var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "82px",
    viewBox: "0 0 92 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "retry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8972905,-4.96451355 C66.2648228,-4.96451355 84.3972905,13.1679541 84.3972905,35.5354865 C84.3972905,57.9030188 66.2648228,76.0354865 43.8972905,76.0354865 C39.5798366,76.0354865 35.4201728,75.3599074 31.5182441,74.1086947 L25.7781318,82.9483358 C25.4773359,83.4115208 24.8580071,83.5431632 24.3948222,83.2423673 C24.2401314,83.14191 24.1162382,83.0006263 24.0368439,82.8341407 L9.85718109,53.1001612 C9.6194535,52.6016595 9.83085276,52.0048276 10.3293546,51.7671 C10.4717515,51.6991932 10.6281946,51.6659402 10.7859009,51.6700581 L43.7166312,52.5299256 C44.2687278,52.5443417 44.704604,53.0035908 44.690188,53.5556874 C44.6853734,53.7400722 44.6296567,53.9195331 44.5291993,54.0742239 L38.1102005,63.9579989 C39.9802357,64.3367069 41.9155494,64.5354865 43.8972905,64.5354865 C59.9135482,64.5354865 72.8972905,51.5517442 72.8972905,35.5354865 C72.8972905,19.5192287 59.9135482,6.53548645 43.8972905,6.53548645 C28.3838687,6.53548645 15.7155378,18.7167681 14.9353755,34.0362536 L3.42455239,34.0355188 C4.21361387,12.3629051 22.0319344,-4.96451355 43.8972905,-4.96451355 Z",
    id: "retry",
    fill: "#fff",
    transform: "translate(43.910921, 39.219650) rotate(236.000000) translate(-43.910921, -39.219650) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.fd810c8cab65e9a50caaafba7d2731ee.svg";
export { ForwardRef as ReactComponent };